import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard_default" }
const _hoisted_2 = { class: "row widget-grid" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDefault',
  setup(__props) {

const cardLevel1 = defineAsyncComponent(() => import("@/components/theme/dashboards/default/cardLevel1.vue"))
const recentOrders = defineAsyncComponent(() => import("@/components/theme/dashboards/default/recentOrders.vue"))
const topSeller = defineAsyncComponent(() => import("@/components/theme/dashboards/default/topSeller.vue"))
const newProduct = defineAsyncComponent(() => import("@/components/theme/dashboards/default/newProduct.vue"))
const topCountries = defineAsyncComponent(() => import("@/components/theme/dashboards/default/topCountries.vue"))
const activityTimeline = defineAsyncComponent(() => import("@/components/theme/dashboards/default/activityTimeline.vue"))
const salesSummary = defineAsyncComponent(() => import("@/components/theme/dashboards/default/salesSummary.vue"))
const weekendCard = defineAsyncComponent(() => import("@/components/theme/dashboards/default/weekendCard.vue"))
const invoiceTable = defineAsyncComponent(() => import("@/components/theme/dashboards/default/invoiceTable.vue"))
const productSales = defineAsyncComponent(() => import("@/components/theme/dashboards/default/productSales.vue"))

return (_ctx: any,_cache: any) => {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumbs, {
        main: "Dashboard",
        mains: "Default",
        title: "Shopping Place Dashboard"
      }),
      _createVNode(_unref(cardLevel1)),
      _createVNode(_unref(recentOrders)),
      _createVNode(_unref(topSeller)),
      _createVNode(_unref(newProduct)),
      _createVNode(_unref(topCountries)),
      _createVNode(_unref(activityTimeline)),
      _createVNode(_unref(salesSummary)),
      _createVNode(_unref(weekendCard)),
      _createVNode(_unref(invoiceTable)),
      _createVNode(_unref(productSales))
    ])
  ]))
}
}

})